var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#1E4554",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2004 20.8003C18.073 20.8003 20.4006 18.8302 20.4006 16.4001C20.4006 13.9701 18.073 12 15.2004 12C12.3279 12 10.0003 13.9701 10.0003 16.4001C10.0003 17.3652 10.3678 18.2577 10.9903 18.9852C10.9028 19.2202 10.7728 19.4278 10.6353 19.6028C10.5153 19.7578 10.3928 19.8778 10.3028 19.9603C10.2578 20.0003 10.2203 20.0328 10.1953 20.0528C10.1828 20.0628 10.1728 20.0703 10.1678 20.0728L10.1628 20.0778C10.0253 20.1803 9.96527 20.3603 10.0203 20.5228C10.0753 20.6853 10.2278 20.8003 10.4003 20.8003C10.9453 20.8003 11.4953 20.6603 11.9528 20.4878C12.1828 20.4003 12.3979 20.3028 12.5854 20.2028C13.3529 20.5828 14.2454 20.8003 15.2004 20.8003ZM21.2007 16.4001C21.2007 19.2077 18.7231 21.3228 15.788 21.5753C16.3955 23.4354 18.4106 24.8004 20.8006 24.8004C21.7557 24.8004 22.6482 24.5829 23.4182 24.2029C23.6057 24.3029 23.8182 24.4004 24.0482 24.4879C24.5058 24.6604 25.0558 24.8004 25.6008 24.8004C25.7733 24.8004 25.9283 24.6879 25.9808 24.5229C26.0333 24.3579 25.9758 24.1779 25.8358 24.0754L25.8308 24.0704C25.8258 24.0654 25.8158 24.0604 25.8033 24.0504C25.7783 24.0304 25.7408 24.0004 25.6958 23.9579C25.6058 23.8754 25.4833 23.7554 25.3633 23.6004C25.2258 23.4254 25.0958 23.2154 25.0083 22.9829C25.6308 22.2578 25.9983 21.3653 25.9983 20.3978C25.9983 18.0777 23.8757 16.1751 21.1832 16.0101C21.1932 16.1376 21.1982 16.2676 21.1982 16.3976L21.2007 16.4001Z",
    fill: "#89A3B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.2c6a11d61af3093aebc366b7e0544802.svg";
export { ForwardRef as ReactComponent };